import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { environment } from '../../../../../../environments/environment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

export interface BankAccountUsageDialogInput
{
    dialogTitle: string;
    accountName: string;
    confirmButtonText: string;
    context: string;
    promptUseForTransactions: boolean;
    disableDeposits?: boolean;
    disablePayments?: boolean;
    supportsTransactions: boolean;
    promptAccountNumbers: boolean;
}

export interface BankAccountUsageDialogForm
{
    accountName: string;
    useForPayments: boolean;
    useForDeposits: boolean;
    useForTransactions: boolean;
    captchaToken: string;
    routingNumber: string;
    accountNumber: string;
}

export interface BankAccountUsageDialogResult
{
    success: boolean;
    usage?: BankAccountUsageDialogForm;
}

@Component({
    selector: 'app-bank-account-usage-dialog',
    templateUrl: './bank-account-usage-dialog.component.html',
    styleUrls: ['./bank-account-usage-dialog.component.scss'],
})
export class BankAccountUsageDialogComponent implements OnInit
{

    public siteKey = environment.RecaptchaSiteKey;
    public disableDeposits: boolean = false;
    public disablePayments: boolean = false;
    public form: FormGroup = null;

    constructor(
            private _dialogRef: MatDialogRef<BankAccountUsageDialogComponent>,
            private _builder: FormBuilder,
            @Inject(MAT_DIALOG_DATA) public data: BankAccountUsageDialogInput,
    ) {
        if (data.disableDeposits) {
            this.disableDeposits = data.disableDeposits;
        }
        if (data.disableDeposits) {
            this.disablePayments = data.disablePayments;
        }
    }

    ngOnInit() {
        this.form = this._builder.group({
            accountName: [
                this.data.accountName,
                Validators.required,
            ],
            useForPayments: [true],
            useForDeposits: [true],
            useForTransactions: [this.data.promptUseForTransactions && this.data.supportsTransactions],
            captchaToken: [
                null,
                Validators.required,
            ],
            accountNumber: [''],
            routingNumber: [''],
        });

        if (this.data.promptAccountNumbers) {
            this.form.get('accountNumber').setValidators(Validators.required);
            this.form.get('routingNumber').setValidators(Validators.required);
        }
    }

    closeDialog(success: boolean) {
        if (success) {
            this._dialogRef.close(<BankAccountUsageDialogResult>{
                success: true,
                usage: <BankAccountUsageDialogForm>this.form.getRawValue(),
            });
        } else {
            this._dialogRef.close(<BankAccountUsageDialogResult>{success: false});
        }
    }

}
